import React from 'react';
import styles from './styles.module.scss';
import classnames from 'classnames';
import icArrowDown from 'assets/svg/ic_arrow_down_fill.svg';

const FAQCollapse = ({
  data,
  isCollapsed,
  toggleCollapse
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.collapse
  }, /*#__PURE__*/React.createElement("button", {
    className: classnames(styles.collapsible, isCollapsed ? styles.active : null),
    onClick: toggleCollapse
  }, /*#__PURE__*/React.createElement("span", null, data.title), /*#__PURE__*/React.createElement("img", {
    src: icArrowDown,
    className: styles.arrow
  })), /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.content, isCollapsed ? styles.active : null)
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, data.content))));
};

export default FAQCollapse;